
import {Component, Prop, PropSync, Vue} from "vue-property-decorator";

@Component({})
export default class StandaloneOnboardingSlide extends Vue {
  @PropSync('isDisplayed') _isDisplayed!: boolean;
  @Prop({default: false}) noCloseButton: boolean;
}
